/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Dealer from "layouts/dealer";
import CreateDealer from "layouts/dealer/components/CreateDealer";
import Territory from "layouts/territory";
import Sales from "layouts/sales";
import Category from "layouts/category";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import Product from "layouts/product";
import CreateProduct from "layouts/product/components/CreateProduct";
import Campaign from "layouts/campaign";
import CreateCampaign from "layouts/campaign/components/CreateCampaign";
import Distributor from "layouts/distributor";
import Stock from "layouts/stock";
import SalesData from "layouts/salesData";
import Payment from "layouts/payment";
import NonActiveDealers from "layouts/nonApprovedDealers";
// @mui icons
import Icon from "@mui/material/Icon";
import CreateTerritory from "layouts/territory/components/CreateTerritory";
import CreateSalesTeam from "layouts/sales/components/CreateSalesTeam";
import PublicRoute from "components/common/PublicRoute";
import PrivateRoute from "components/common/PrivateRoute";
import CreateCategory from "layouts/category/components/CreateCategory";
import ForgotPassword from "layouts/authentication/forgot-password/ForgotPassword";
import CreateDistributor from "layouts/distributor/components/CreateDistributor";
import Dealers from "layouts/dashboard/components/Dealers";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/",
    component: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    name: "Top Dealers",
    key: "",
    route: "/top-dealers",
    component: (
      <PrivateRoute>
        <Dealers />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Dealer Management",
    key: "dealer-management",
    icon: <Icon fontSize="small">handshakeIcon</Icon>,
    route: "/dealer-management",
    component: (
      <PrivateRoute>
        <Dealer />
      </PrivateRoute>
    ),
  },
  {
    // type: "collapse",
    name: "Dealer",
    key: "dealer-management",
    icon: <Icon fontSize="small">handshakeIcon</Icon>,
    route: "/dealer-management/create",
    component: (
      <PrivateRoute>
        <CreateDealer />
      </PrivateRoute>
    ),
  },
  {
    // type: "collapse",
    name: "Dealer",
    icon: <Icon fontSize="small">handshakeIcon</Icon>,
    route: "/dealer-management/edit",
    component: (
      <PrivateRoute>
        <CreateDealer />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Non Active Dealers",
    key: "non-active-dealers",
    icon: <Icon fontSize="small">handshakeIcon</Icon>,
    route: "/non-active-dealers",
    component: (
      <PrivateRoute>
        <NonActiveDealers />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Territory Management",
    key: "territory-management",
    icon: <Icon fontSize="small">businessIcon</Icon>,
    route: "/territory-management",
    component: (
      <PrivateRoute>
        <Territory />
      </PrivateRoute>
    ),
  },
  {
    key: "territory-management",
    name: "Create Territory",
    icon: <Icon fontSize="small">businessIcon</Icon>,
    route: "/territory-management/create",
    component: (
      <PrivateRoute>
        <CreateTerritory />
      </PrivateRoute>
    ),
  },
  {
    key: "territory-management",
    name: "Edit Territory",
    icon: <Icon fontSize="small">businessIcon</Icon>,
    route: "/territory-management/edit",
    component: (
      <PrivateRoute>
        <CreateTerritory />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Sales Team Management",
    key: "sales-team",
    icon: <Icon fontSize="small">groupIcon2</Icon>,
    route: "/sales-team",
    component: (
      <PrivateRoute>
        <Sales />
      </PrivateRoute>
    ),
  },
  {
    key: "sales-team",
    name: "Sales Team Management",
    icon: <Icon fontSize="small">groupIcon2</Icon>,
    route: "/sales-team/create",
    component: (
      <PrivateRoute>
        <CreateSalesTeam />
      </PrivateRoute>
    ),
  },
  {
    key: "sales-team",
    name: "Sales Team Management",
    icon: <Icon fontSize="small">groupIcon2</Icon>,
    route: "/sales-team/edit",
    component: (
      <PrivateRoute>
        <CreateSalesTeam />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Category Management",
    key: "category-management",
    icon: <Icon fontSize="small">categoryIcon</Icon>,
    route: "/category-management",
    component: (
      <PrivateRoute>
        <Category />
      </PrivateRoute>
    ),
  },
  {
    key: "category-management",
    name: "Create Category",
    icon: <Icon fontSize="small">categoryIcon</Icon>,
    route: "/category-management/create",
    component: (
      <PrivateRoute>
        <CreateCategory />
      </PrivateRoute>
    ),
  },
  {
    key: "category-management",
    name: "Edit Category",
    icon: <Icon fontSize="small">categoryIcon</Icon>,
    route: "/category-management/edit",
    component: (
      <PrivateRoute>
        <CreateCategory />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Product Management",
    key: "product-management",
    icon: <Icon fontSize="small">inventoryIcon</Icon>,
    route: "/product-management",
    component: (
      <PrivateRoute>
        <Product />
      </PrivateRoute>
    ),
  },
  {
    key: "product-management",
    name: "Create Product",
    icon: <Icon fontSize="small">inventoryIcon</Icon>,
    route: "/product-management/create",
    component: (
      <PrivateRoute>
        <CreateProduct />
      </PrivateRoute>
    ),
  },
  {
    key: "product-management",
    name: "Edit Product",
    icon: <Icon fontSize="small">inventoryIcon</Icon>,
    route: "/product-management/edit",
    component: (
      <PrivateRoute>
        <CreateProduct />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Campaign Management",
    key: "campaign-management",
    icon: <Icon fontSize="small">campaignIcon</Icon>,
    route: "/campaign-management",
    component: (
      <PrivateRoute>
        <Campaign />
      </PrivateRoute>
    ),
  },
  {
    key: "campaign-management",
    name: "Create Campaign",
    icon: <Icon fontSize="small">campaignIcon</Icon>,
    route: "/campaign-management/create",
    component: (
      <PrivateRoute>
        <CreateCampaign />
      </PrivateRoute>
    ),
  },
  {
    key: "campaign-management",
    name: "Edit Campain",
    icon: <Icon fontSize="small">campaignIcon</Icon>,
    route: "/campaign-management/edit",
    component: (
      <PrivateRoute>
        <CreateCampaign />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Distributor Management",
    key: "distributor-management",
    icon: <Icon fontSize="small">businessIcon</Icon>,
    route: "/distributor-management",
    component: (
      <PrivateRoute>
        <Distributor />
      </PrivateRoute>
    ),
  },
  {
    key: "distributor-management",
    name: "Create Distributor",
    icon: <Icon fontSize="small">businessIcon</Icon>,
    route: "/distributor-management/create",
    component: (
      <PrivateRoute>
        <CreateDistributor />
      </PrivateRoute>
    ),
  },
  {
    key: "distributor-management",
    name: "Edit Distributor",
    icon: <Icon fontSize="small">businessIcon</Icon>,
    route: "/distributor-management/edit",
    component: (
      <PrivateRoute>
        <CreateDistributor />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Stock Management",
    key: "stock-management",
    icon: <Icon fontSize="small">inventoryIcon</Icon>,
    route: "/stock-management",
    component: (
      <PrivateRoute>
        <Stock />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Payment Management",
    key: "payment-management",
    icon: <Icon fontSize="small">inventoryIcon</Icon>,
    route: "/payment-management",
    component: (
      <PrivateRoute>
        <Payment />
      </PrivateRoute>
    ),
  },
  {
    type: "collapse",
    name: "Sales Data Sync",
    key: "salesData-management",
    icon: <Icon fontSize="small">businessIcon</Icon>,
    route: "/salesData-management",
    component: (
      <PrivateRoute>
        <SalesData />
      </PrivateRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: (
  //     <PrivateRoute>
  //       <Profile />
  //     </PrivateRoute>
  //   ),
  // },
  {
    // type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: (
      <PublicRoute>
        <SignIn />
      </PublicRoute>
    ),
  },
  {
    // type: "collapse",
    name: "Forgot Password",
    key: "forgot-password",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/forgot-password",
    component: (
      <PublicRoute>
        <ForgotPassword />
      </PublicRoute>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default routes;
